import React, { useRef } from "react";
import { designations } from "../data/OnboardingData";
import { UserIcon, UploadIcon, PhoneIcon, ArrowRightIcon, ArrowLeftIcon } from "../icons/OnboardingIcons";

const OwnerDetailsStep = ({ formData, updateFormData, onNext, onBack }) => {
  const fileInputRef = useRef(null);

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert("File size should not exceed 5MB");
        return;
      }

      // Validate file type
      if (!["image/jpeg", "image/png", "image/gif"].includes(file.type)) {
        alert("Please upload JPG, PNG, or GIF format");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        updateFormData("profilePhoto", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const canContinue =
    formData.fullName &&
    formData.designation &&
    formData.alternateContact &&
    formData.emergencyContact;

  return (
    <div className="v2-owner-details-step">
      <div className="v2-step-header">
        <div className="v2-step-icon v2-step-icon--red">
          <UserIcon />
        </div>
        <h2 className="v2-step-title">Owner Details</h2>
      </div>

      <p className="v2-step-description">Personal information of the gym owner</p>

      {/* Profile Photo */}
      <div className="v2-profile-upload">
        <label className="v2-form-label">Profile Photo</label>
        <div className="v2-profile-upload__container">
          <div
            className={`v2-profile-upload__preview ${
              formData.profilePhoto ? "v2-profile-upload__preview--has-image" : ""
            }`}
          >
            {formData.profilePhoto ? (
              <img
                src={formData.profilePhoto}
                alt="Profile"
                className="v2-profile-upload__image"
              />
            ) : (
              <div className="v2-profile-upload__placeholder">
                <UserIcon size={32} />
              </div>
            )}
          </div>
          <button
            type="button"
            className="v2-btn v2-btn--upload"
            onClick={() => fileInputRef.current?.click()}
          >
            <UploadIcon />
            Upload Photo
          </button>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/png,image/gif"
            onChange={handlePhotoUpload}
            style={{ display: "none" }}
          />
          <p className="v2-profile-upload__hint">JPG, PNG or GIF. Max 5MB.</p>
        </div>
      </div>

      {/* Full Name and Designation */}
      <div className="v2-form-row">
        <div className="v2-form-group">
          <label className="v2-form-label">
            Full Name <span className="v2-form-required">*</span>
          </label>
          <input
            type="text"
            className="v2-form-input"
            placeholder="Enter full name"
            value={formData.fullName}
            onChange={(e) => updateFormData("fullName", e.target.value)}
          />
        </div>

        <div className="v2-form-group">
          <label className="v2-form-label">
            Designation <span className="v2-form-required">*</span>
          </label>
          <select
            className="v2-form-select"
            value={formData.designation}
            onChange={(e) => updateFormData("designation", e.target.value)}
          >
            <option value="">Select designation</option>
            {designations.map((designation) => (
              <option key={designation} value={designation}>
                {designation}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Alternate and Emergency Contacts */}
      <div className="v2-form-row">
        <div className="v2-form-group">
          <label className="v2-form-label">Alternate Contact</label>
          <div className="v2-form-input-icon">
            <PhoneIcon size={18} />
            <input
              type="tel"
              className="v2-form-input v2-form-input--with-icon"
              placeholder="+91 9876543210"
              value={formData.alternateContact}
              onChange={(e) => updateFormData("alternateContact", e.target.value)}
            />
          </div>
        </div>

        <div className="v2-form-group">
          <label className="v2-form-label">Emergency Contact</label>
          <div className="v2-form-input-icon">
            <PhoneIcon size={18} />
            <input
              type="tel"
              className="v2-form-input v2-form-input--with-icon"
              placeholder="+91 9876543210"
              value={formData.emergencyContact}
              onChange={(e) => updateFormData("emergencyContact", e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="v2-step-actions">
        <button className="v2-btn v2-btn--back" onClick={onBack}>
          <ArrowLeftIcon />
          Back
        </button>
        <button
          className="v2-btn v2-btn--primary"
          onClick={onNext}
          disabled={!canContinue}
        >
          Continue to Plan Selection
          <ArrowRightIcon />
        </button>
      </div>
    </div>
  );
};

export default OwnerDetailsStep;
